module.exports = __webpack_public_path__ + "media/images/log/log-graph-bg-21335ac4d8006a9339a2aafb88f47295.svg";